// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".gw-currency-switch{margin-bottom:var(--spacing-sm)}.gw-currency-switch .dn-button{font-weight:var(--font-weight-primary-regular)}.gw-currency-switch__content{line-height:var(--lineHeight-sm);margin-top:.5em}.gw-currency-switch__item{cursor:pointer;margin-top:.25em}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
